import { IAngularStatic } from "angular";
import { PartialObserver, Subject, Subscribable, Subscription } from "rxjs";

export interface IEventEmitter<T> extends Subscribable<T> {
    emit(value?: T): void;
}

export class SharedEventEmitter<T> extends Subject<T> implements IEventEmitter<T> {
    __isAsync: boolean;

    constructor(isAsync: boolean = true) {
        super();
        this.__isAsync = isAsync;
    }

    emit(value?: T) {
        super.next(value);
    }

    override subscribe(observerOrNext?: any, error?: any, complete?: any): Subscription {
        let nextFn = observerOrNext;
        let errorFn = error || (() => null);
        let completeFn = complete;

        if (observerOrNext && typeof observerOrNext === 'object') {
            const observer = observerOrNext as PartialObserver<unknown>;
            nextFn = observer.next?.bind(observer);
            errorFn = observer.error?.bind(observer);
            completeFn = observer.complete?.bind(observer);
        }

        if (this.__isAsync) {
            errorFn = _wrapInTimeout(errorFn);

            if (nextFn) {
                nextFn = _wrapInTimeout(nextFn);
            }

            if (completeFn) {
                completeFn = _wrapInTimeout(completeFn);
            }
        }

        const sink = super.subscribe({ next: nextFn, error: errorFn, complete: completeFn });

        if (observerOrNext instanceof Subscription) {
            observerOrNext.add(sink);
        }

        return sink;
    }
}

const _wrapInTimeout = (fn: (value: unknown) => any) => (value: unknown) => {
    if (window['angular']) {
        // angularjs exists, use $timeout
        const angularJs: IAngularStatic = window['angular'];
        const $injector = angularJs.element('#ClearViewApp').injector();
        const $timeout = $injector.get('$timeout');
        $timeout(fn, undefined, true, value);
    } else {
        window.setTimeout(fn, undefined, value);
    }
};
